import React, { useState } from "react";
import "../Styles/advancefilter.css";
import { IoBed } from "react-icons/io5";

const AdvanceFilter = ({
  closePopup,
  setBedroom,
  setBathroom,
  setAreaSqft,
  setAmenities,
  selectedType,
  setSelectedType
}) => {
  const [bedrooms, setBedrooms] = useState("");
  const [bathrooms, setBathrooms] = useState("");
  const [areaSize, setAreaSize] = useState(0);
  const [selectedAmenities, setSelectedAmenities] = useState([]);

  const handleAmenitiesChange = (event) => {
    const value = event.target.value;
    setSelectedAmenities((prev) =>
      prev.includes(value)
        ? prev.filter((amenity) => amenity !== value)
        : [...prev, value]
    );
  };
  
  const applyFilters = () => {
    setBedroom(bedrooms);
    setBathroom(bathrooms);
    setAreaSqft(areaSize);
    setAmenities(selectedAmenities);
    closePopup();
  };

  return (
    <>
      <div className="container filter-section bg-white rounded shadow-sm">
        {/* Dropdown Filters */}
        <div className="row mb-4">
          <div className="col-md-4 mb-3">
            <label htmlFor="dropdownStatus" className="form-label">
              Property Status
            </label>
            <select
              className="form-select pop-up-form-select w-100 d-flex align-items-center"
              id="dropdownStatus"
              value={selectedType}
              onChange={(e) => setSelectedType(e.target.value)}
            >
              <option value="sell" selected={selectedType === "sell"}>For Sale</option>
              <option value="rent" selected={selectedType === "rent"}>For Rent</option>
              <option value="developer" selected={selectedType === "developer"}>For Developer</option>
            </select>
          </div>
          <div className="col-md-4 mb-3">
            <label htmlFor="dropdownBedrooms" className="form-label">
              Bedrooms
            </label>
            <select
              className="form-select pop-up-form-select w-100 d-flex align-items-center"
              id="dropdownBedrooms"
              value={bedrooms}
              onChange={(e) => setBedrooms(e.target.value)}
            >
              <option disabled hidden>
                Bedrooms
              </option>
              <option value="">Select Bedrooms</option>
              <option value="1">1 Bedroom</option>
              <option value="2">2 Bedrooms</option>
              <option value="3">3+ Bedrooms</option>
            </select>
          </div>
          <div className="col-md-4 mb-3">
            <label htmlFor="dropdownBathrooms" className="form-label">
              <IoBed /> Bathrooms
            </label>
            <select
              className="form-select pop-up-form-select w-100 d-flex align-items-center"
              id="dropdownBathrooms"
              value={bathrooms}
              onChange={(e) => setBathrooms(e.target.value)}
            >
              <option disabled hidden>
                Bathrooms
              </option>
              <option value="">Select Bathrooms</option>
              <option value="1">1 Bathroom</option>
              <option value="2">2 Bathrooms</option>
              <option value="3">3+ Bathrooms</option>
            </select>
          </div>
        </div>

        {/* Range Slider for Area Size */}
        <div className="row mb-4">
          <div className="col-md-4">
            <label htmlFor="areaSize" className="form-label">
              Area Size (sq ft)
            </label>
            <input
              type="range"
              className="form-range"
              id="areaSize"
              min={500}
              max={3000}
              step={100}
              value={areaSize}
              onChange={(e) => setAreaSize(e.target.value)}
            />
            <div className="text-end">{areaSize} sq ft</div>
          </div>
          <div className="col-md-6 Facilities-col">
            <h5>Facilities</h5>
            <div className="facilities-list">
              {[
                "Air Conditioning",
                "Swimming Pool",
                "Central Heating",
                "Gym",
                "Alarm",
                "WiFi",
                "TV Cable",
                "Outdoor Shower",
              ].map((facility, index) => (
                <div className="form-check" key={index}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={`facility${index + 1}`}
                    checked={selectedAmenities.includes(facility)}
                    value={facility}
                    onChange={handleAmenitiesChange}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`facility${index + 1}`}
                  >
                    {facility}
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>



        {/* Apply Filters Button */}
        <div className="text-end">
          <button onClick={applyFilters} className="btn btn-primary">
            Apply Filter
          </button>
        </div>
      </div>
    </>
  );
};

export default AdvanceFilter;
